import React, { useState, useEffect, useRef } from 'react';
import '../Assets/css/logindoc.scss';
import '../Assets/css/loginresponsivedoc.scss';
import { connect } from 'react-redux';
import { loaderStateTrue, loaderStateFalse, setGlobalSeoData } from '../../../Actions/AllAction';
import { getfetchApiKey } from '../Controller/LoginController';
import { getMarketplaceData } from '../../../Utility/Controller/UtilityController';
import { hotelRoomTypesSearchList } from '../../../V1/Modules/Home/Controller/HomeController';
import { serachDataFormatingFn } from '../../../V1/Modules/Home/Model/HomeModel';
import Utility from '../../../Utility/Utility';
import moment from 'moment';

const AppLandingPage = (props) => {
	const [state, setState] = useState({})
	const [isRedirecting, setIsRedirecting] = useState(false);

	const handleRedirect = async (apiKey, seoData) => {
		const language = localStorage.getItem('i18nextLng') || 'en';

		if (apiKey !== "") {
			const landingScreen = seoData?.data?.find(item => item.key === "landing_screen")?.value;
			if (landingScreen) {
				switch (landingScreen.toLowerCase()) {
					case 'home':
						props.history.push(`/${language}/home`);
						break;
					case 'single_property_listing':
					case 'single property listing':
						try {
							const searchData = {
								destination: "",
								start_date: new Date(),
								end_date: new Date(new Date().getTime() + 24 * 60 * 60 * 1000),
								adult: 1,
								children: 0,
								children_age: [],
								filterData: {}
							};

							let formattedData = serachDataFormatingFn(searchData, false);
							formattedData['limit'] = 1;
							formattedData['offset'] = 0;
							const response = await hotelRoomTypesSearchList(formattedData);

							if (response.success && response.data && response.data.length > 0) {
								const branchData = response.data[0]?.branch_details?.[0] || {};
								const queryParamsData = {
									destination: searchData.destination,
									start_date: searchData.start_date,
									end_date: searchData.end_date,
									adult: searchData.adult,
									children: searchData.children,
									children_age: searchData.children_age,
									filterData: searchData.filterData || {}
								};

								const queryParams = Utility.buildUrlParams(queryParamsData);
								props.history.push(`/${language}/property-details/${branchData.slug}?${queryParams}`);
							} else {
								props.history.push(`/${language}/home`);
							}
						} catch (error) {
							console.error("Error fetching branch list:", error);
							props.history.push(`/${language}/home`);
						}
						break;
					case 'multi_property_listing':
					case 'multi property listing':
						props.history.push(`/${language}/search`);
						break;
					default:
						props.history.push(`/${language}/home`);
						break;
				}
			} else {
				props.history.push(`/${language}/home`);
			}
		} else {
			props.history.push(`/${language}/home`);
		}
	}

	useEffect(() => {
		if (!isRedirecting) {
			setIsRedirecting(true);

			getfetchApiKey().then(async (response) => {
				if (response.success) {
					const apiKey = response.api_key || '';
					localStorage.setItem('api_key', apiKey);
					// const apiKey = "radiant";
					if (apiKey !== "") {
						try {
							const seoResponse = await getMarketplaceData();
							if (seoResponse?.success && seoResponse?.data) {
								const tempData = {
									pageTitle: seoResponse.orgDetails?.org_name || '',
									description: `${seoResponse.orgDetails?.org_name || ''} - Book your stay`,
									pageUrl: window.location.href,
									imageUrl: seoResponse.orgDetails?.org_logo ? JSON.parse(seoResponse.orgDetails.org_logo)?.file_obj : '',
									siteTitle: seoResponse.orgDetails?.org_name,
									org: seoResponse.orgDetails,
									data: seoResponse.data
								};
								props.setGlobalSeoData(tempData);
								handleRedirect(apiKey, tempData);
							} else {
								handleRedirect(apiKey, null);
							}
						} catch (error) {
							console.error("Error fetching SEO data:", error);
							handleRedirect(apiKey, null);
						}
					} else {
						handleRedirect(apiKey, null);
					}
				} else {
					localStorage.setItem('api_key', "");
					handleRedirect("", null);
				}
			}).catch((error) => {
				console.error("Error fetching API key:", error);
				localStorage.setItem('api_key', "");
				handleRedirect("", null);
			});
		}
	}, []);

	return (
		<></>
	);
}

const mapStateToProps = (globalState) => {
	return {
		token: globalState.LoginReducer.token,
		globalSeoData: globalState.mainReducerData.globalSeoData,
	};
}

export default connect(mapStateToProps, { loaderStateTrue, loaderStateFalse, setGlobalSeoData })(AppLandingPage);


